<template>
  <PopupModal :show="show" :enable-click-away="false" @close-popup="closeModal()">
    <div
      v-if="show"
      class="fixed bg-white rounded-2xl top-[calc(50%-44px)] left-1/2 transform -translate-y-1/2 -translate-x-1/2 px-[10px] xs:px-6 pt-[32px] pb-[32px] flex flex-col z-50 font-aktiv-grotesk-medium w-[300px] xs:w-auto max-w-[343px]"
      @wheel.prevent
      @touchmove.prevent
      @scroll.prevent
    >
      <div class="mb-8 flex justify-center">
        <img class="h-[64px] w-[64px]" alt="Email" :src="emailIcon" />
      </div>
      <h1 class="text-[24px] leading-[32px] font-aktiv-grotesk-medium text-center mb-4">
        <span class="xs:whitespace-nowrap">{{
          $t('copy.photoDropPage.downloadModal.header')
        }}</span>
      </h1>
      <p class="text-[16px] leading-[24px] font-aktiv-grotesk text-center mb-8">
        {{ $t('copy.photoDropPage.downloadModal.description') }}
      </p>
      <div
        :class="[
          'font-aktiv-grotesk-trial w-full mx-auto max-w-[295px] rounded-[100px] text-white text-[20px] leading-[24px] text-center py-[12px] mb-6 cursor-pointer',
          isGIC ? 'bg-orange hover:bg-[#F27521]' : 'bg-lightblue hover:bg-blue-600',
          isSending ? 'opacity-50 pointer-events-none' : '',
        ]"
        @click="download()"
      >
        {{ isSending ? 'Sending...' : $t('copy.photoDropPage.downloadModal.sendToMyEmail') }}
      </div>
      <div
        :class="[
          'text-[20px] leading-[24px] text-center font-aktiv-grotesk-trial cursor-pointer',
          isGIC ? 'text-orange' : 'text-lightblue',
        ]"
        @click="closeModal()"
      >
        {{ $t('copy.photoDropPage.downloadModal.cancel') }}
      </div>
    </div>
  </PopupModal>
</template>

<script>
import axios from 'axios';
import PopupModal from '../common/PopupModal.vue';
import { mapState } from 'vuex';
import { PHOTODROP_DOWNLOAD_TOAST_SCOPE } from '@/store/modules/toast';
import { isGICPage } from '@/utils/conference-type';
import mixpanel from '@/utils/mixpanel';

export default {
  name: 'PhotoDownloadModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSending: false,
    };
  },
  computed: {
    ...mapState('photos', ['selectedPhotos']),
    ...mapState('user', ['token']),
    isGIC() {
      return isGICPage();
    },
    emailIcon() {
      return this.isGIC
        ? require('../../../public/assets/icons/email-orange.svg')
        : require('../../../public/assets/icons/email.svg');
    },
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
    download() {
      if (this.isSending) return;
      this.isSending = true;
      const fileNames = this.selectedPhotos.map(url => {
        return new URL(url).pathname.split('/').pop();
      });
      try {
        mixpanel.track('Photodrop Bulk Download', {
          page_url: this.$route.path,
          download_type: 'email',
          file_quantity: this.selectedPhotos.length,
          page: 'photodrop',
        });
      } catch (e) {
        // noop
      }
      fileNames.forEach(fileName => {
        try {
          mixpanel.track('Photodrop Individual File Downloaded', {
            file_name: fileName,
            download_type: 'email',
            page_url: this.$route.path,
            page: 'photodrop',
          });
        } catch (e) {
          // noop
        }
      });

      axios
        .request(process.env.VUE_APP_API_URL + '/photo/multi-download', {
          method: 'post',
          data: { presignedUrls: this.selectedPhotos },
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then(() => {
          this.$store.dispatch(
            'toast/success',
            {
              message:
                'Download link successfully sent!\nPlease check your inbox in a few minutes.',
              scope: PHOTODROP_DOWNLOAD_TOAST_SCOPE,
            },
            {
              root: true,
            },
          );
          this.closeModal();
        })
        .catch(error => {
          this.$store.dispatch(
            'toast/error',
            {
              message: 'An error occurred while preparing your download link. Please try again.',
              scope: PHOTODROP_DOWNLOAD_TOAST_SCOPE,
            },
            {
              root: true,
            },
          );
          console.error(error);
        })
        .finally(() => {
          this.isSending = false;
        });
    },
  },
  components: { PopupModal },
};
</script>

<style scoped></style>
